import { salutations } from "../Enums/enumValues";
import { Enum, UseOfName } from "../interfaces/enum";

interface InputProps {
  salutation?: string;
  initials?: string;
  firstName?: string;
  lastName?: string;
  inserts?: string;
  hasPartner?: boolean;
  partnerInserts?: string;
  partnerLastName?: string;
  useOfName?: UseOfName;
}

export function getFullName(input: InputProps) {
  const salutationOptions = salutations() as Enum[];
  const selectedSalutation = salutationOptions.find((s) => s.value === input.salutation);
  const salutation = `${selectedSalutation ? `${selectedSalutation.label} ` : ""}`;
  const initials = `${input.initials ? `${input.initials} ` : ""}`;
  const firstName = `${input.firstName ? `(${input.firstName})` : ""}`;
  const lastname = `${input.inserts ? ` ${input.inserts}` : ""}${input.lastName ? ` ${input.lastName}` : ""}`;
  const partnerLastname = input.hasPartner
    ? `${input.partnerInserts ? ` ${input.partnerInserts}` : ""}${
        input.partnerLastName ? ` ${input.partnerLastName}` : ""
      }`
    : "";

  const fullName = `${salutation}${initials}${firstName}`;

  if (!input.hasPartner) {
    return `${fullName}${lastname}`;
  }

  switch (input.useOfName) {
    case "PartnerNameOwnName":
      return `${fullName}${partnerLastname}${lastname}`;
    case "OwnNamePartnerName":
      return `${fullName}${lastname}${partnerLastname}`;
    case "PartnerName":
    default:
      return `${fullName}${partnerLastname}`;
  }
}
